module.exports = __webpack_public_path__ + "img/085.a578b753.png";